import CameraRig from './camera/CameraRig';
import EyeSphere from './experience/EyeSphere';
import SilhouetteFigure from './experience/SilhouetteFigure';
import ReflectiveFloor from './experience/ReflectiveFloor';
import OrbitalParticles from './experience/OrbitalParticles';
import { FLOOR_Y, SCENE_GROUP_Y, REFLECTION } from '../constants/scene';

export default function Scene() {
  return (
    <>
      <CameraRig />

      <ambientLight intensity={0.15} />

      <group position={[0, SCENE_GROUP_Y, 0]}>
        <EyeSphere />
        <OrbitalParticles />

        <group position={REFLECTION.position} scale={REFLECTION.scale}>
          <EyeSphere reflection />
        </group>

        <SilhouetteFigure position={[0, FLOOR_Y, 6]} scale={0.35} />
        <ReflectiveFloor yPosition={FLOOR_Y} />
      </group>
    </>
  );
}
